import { api } from '@cwd/lib/main';
import { UserReference } from '@cwd/Account/UserReference';

export interface WidgetConfiguration {
    WidgetConfigurationId: string;
    AccountId: string;

    Created: Date;
    CreatedBy: UserReference;
    Modified: Date;
    ModifiedBy: UserReference;

    Data: string;
    HasUnpublishedChanges: boolean;

    WidgetPath: string;
    TestWidgetPath: string;
}

export async function loadWidgetConfiguration(): Promise<WidgetConfiguration> {
    return api.get('/widgets');
}
export async function saveWidgetConfiguration(ruleset: string, publish: boolean): Promise<WidgetConfiguration> {
    return api.post('/widgets', { Data: ruleset, Publish: publish }, 'application/json');
}
// // this.publish = () => {
// //     return this.postChanges(true).done(()=>{
// //         //   this.configuration().HasUnpublishedChanges(true);
// //     });
// // }
// // this.saveChanges = () => {
// //     return this.postChanges(false).done(()=>{
// //         //  this.configuration().HasUnpublishedChanges(true);
// //     });
// // }
// this.postChanges = (publish:boolean) => {
//
//
//     return $.fn.application.post('/widgets', {Data: updatedConfiguration, Publish:publish}).done( (cfg)=> {
//         this.configuration(ko.mapping.fromJS(cfg));
//         alertSuccess("success", "Saved widget")
//
//     }).fail(() => {
//         alertError("Failed", "Could not save widget")
//     })
//     console.log('updated conf', updatedConfiguration);
// }

export interface WebContent {
    WebContentId: string;
    AccountId: string;
    Name: string;
    Description: string;
    Created: string;
    CreatedByUserId: string;
    CreatedBy: UserReference;
    Modified: string;
    ModifiedByUserId: string;
    ModifiedBy: UserReference;
    ContentType: string;
    Data: any;
}

export async function postWebContentChanges(content: WebContent): Promise<WebContent> {
    return await api.post('/widgets/webContent', content);
}
export async function getContent(webContentId: string): Promise<WebContent[]> {
    return api.get("/widgets/webcontent/forms?$filter=WebContentId eq guid'" + webContentId + "'");
}

export interface FormListItem {
    WebContentId: string;
    Name: string;
    Description: string;
    ModifiedBy: UserReference;
}

export async function loadForms(): Promise<FormListItem[]> {
    return api.get('/widgets/webcontent/forms?$select=WebContentId,Name,ModifiedBy,Description');
}
